import React from 'react'
import AllProducts from '../components/AllProducts';
import { Helmet } from 'react-helmet';

const Shop = () => {
    return (
        // <div className='bg-white md:py-[100px] p-10 w-full'>
        //     <div className='capitalize text-[clamp(1.8rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
        //         <span className='text-black'>Customer </span>
        //         <span className='text-primary'>favourites </span>
        //     </div>
        //     <div className='mt-[50px] flex items-center flex-wrap justify-center gap-y-[50px] gap-x-[100px]'>
        //         {
        //             products.length ? products.sort((a, b) => a.productQty - b.productQty).map(product => {
        //                 return (
        //                     <div key={product.productId} className='flex flex-col  items-center justify-center p-4 rounded-xl'>
        //                         <img src={ProductImage} alt={product.productName} className='w-[198px]' />
        //                         <div className='w-full flex items-center flex-wrap gap-x-10 justify-center mt-2'>
        //                             <p className='text-[24px] font-[600] leading-[normal] capitalize'>{product.productName.replaceAll('_', ' ')}</p>
        //                             <p className='text-[20px] font-[600] leading-[normal] text-secondary'>{product.productQty} Bottles</p>
        //                         </div>
        //                         <div className='my-[17px] flex gap-2 items-center justify-center h-6'>
        //                             <div className='flex gap-[3px]'>
        //                                 <img src={Star} alt="Star" />
        //                                 <img src={Star} alt="Star" />
        //                                 <img src={Star} alt="Star" />
        //                                 <img src={Star} alt="Star" />
        //                                 <img src={Star} alt="Star" />
        //                             </div>
        //                             <p className='text-[16px] font-[400] leading-[normal] text-secondary'>5 Out of 5 Rating</p>
        //                         </div>
        //                         <p className='text-[24px] font-[600] leading-[normal] mb-5'>${product.price}</p>
        //                         <Link to={`/${product.productName.replaceAll('_', '-')}`} className='btn-primary flex items-center'>Learn More</Link>
        //                     </div>
        //                 )
        //             }) : <></>
        //         }
        //     </div>
        // </div<>
        <>
            <Helmet>
                <title>Shop - Supreme Nutra Shop</title>
                <meta name="description" content="This is a detailed description of the page content for better SEO" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="My SEO Optimized Page" />
                <meta property="og:description" content="This is a detailed description of the page content for better SEO" />
                <meta property="og:image" content="https://www.example.com/image.jpg" />
                <link rel="canonical" href="https://www.example.com/page" />
            </Helmet>
            <AllProducts />
        </>
    )
}

export default Shop